import { createBrowserRouter, Navigate } from 'react-router-dom';
import { MainLayout } from '@/components/layout/MainLayout';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { PublicRoute } from '@/components/auth/PublicRoute';
import { Login } from '@/pages/Login';
import { Dashboard } from '@/pages/Dashboard';
import { Websites } from '@/pages/Websites';
import { WebsiteDetail } from '@/pages/WebsiteDetail';
import { ArticleDetail } from '@/pages/ArticleDetail';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: 'dashboard',
        element: <Dashboard />,
      },
      {
        path: 'websites',
        element: <Websites />,
      },
      {
        path: 'websites/:websiteId',
        element: <WebsiteDetail />,
      },
      {
        path: 'websites/:websiteId/articles/:articleId',
        element: <ArticleDetail />,
      },
    ],
  },
]);
